export const triggerDownload = (url: string, fileName: string): void => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    document.body.removeChild(a);
  }
};

export const getFileIconByMimeType = (mimeType: string | null | undefined, fileName: string): string => {
  if (mimeType?.startsWith('image/')) return 'rioglyph rioglyph-file-image';
  if (mimeType === 'application/pdf') return 'rioglyph rioglyph-file-pdf';
  if (mimeType?.includes('wordprocessingml')) return 'rioglyph rioglyph-file-doc';
  if (mimeType?.includes('spreadsheetml')) return 'rioglyph rioglyph-file-xls';
  if (mimeType === 'text/plain') return 'rioglyph rioglyph-file-text';
  const lower = (fileName ?? '').toLowerCase();
  if (lower.endsWith('.pdf')) return 'rioglyph rioglyph-file-pdf';
  if (lower.endsWith('.docx') || lower.endsWith('.doc')) return 'rioglyph rioglyph-file-doc';
  if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) return 'rioglyph rioglyph-file-xls';
  if (lower.endsWith('.txt')) return 'rioglyph rioglyph-file-text';
  if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.gif') || lower.endsWith('.webp')) return 'rioglyph rioglyph-file-image';
  return 'rioglyph rioglyph-file';
};
